export default () => ({
    selectedArchiveProject: null,
    searchQueryData: {
        query: '',
        sort: {icon: 'sort-alphabetical-ascending', text: 'Alphabetically ascending', value: 'ASCENDING'},
        projectType: {icon: '', text: 'All', value: 'ALL'},
        active: {icon: 'calendar-check', text: 'Active', value: 'Active'},
    },
    statusDataBySite:[],
    allRules: null,
    appliedProjectRule: null,
    appliedSiteRules: null,
    appliedDeviceRules: null
});
